// Starting points only: no prices or promised business quotas are preconfigured.
export const memberPlanPresets = [
  {
    code: 'creator_pro',
    name: '创作者 Pro',
    audience: 'account',
    level: 1,
    display_order: 10,
    description: '面向独立创作者的个人会员等级。具体服务内容以正式发布的权益说明为准。',
  },
  {
    code: 'creator_plus',
    name: '创作者 Plus',
    audience: 'account',
    level: 2,
    display_order: 20,
    description: '面向进阶创作者的个人会员等级。具体服务内容以正式发布的权益说明为准。',
  },
  {
    code: 'studio_pro',
    name: '工作室 Pro',
    audience: 'organization',
    level: 1,
    display_order: 30,
    description:
      '面向团队与工作室的组织会员等级。会员归属本组织，具体服务内容以正式发布的权益说明为准。',
  },
  {
    code: 'organization_plus',
    name: '机构 Plus',
    audience: 'organization',
    level: 2,
    display_order: 40,
    description:
      '面向企业与机构的组织会员等级。会员归属本组织，具体服务内容以正式发布的权益说明为准。',
  },
] as const;
